import React from 'react';
import { initials } from '../../utils/format';
const sizes = {
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-10 w-10 text-xs',
  lg: 'h-12 w-12 text-sm'
};
interface AvatarProps {
  name: string;
  size?: keyof typeof sizes;
  solid?: boolean;
}
export function Avatar({
  name,
  size = 'md',
  solid = false
}: AvatarProps) {
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${solid ? 'bg-accent text-on-accent' : 'bg-accent-soft text-accent'} ${sizes[size]}`} data-id="element-100" data-mp="30dxithej0b85">
      {initials(name)}
    </span>;
}